import { Swiper, Navigation, Autoplay } from 'swiper'

Swiper.use([Navigation, Autoplay])

export default () => {
    const sliders = document.querySelectorAll('.auto-slider__container')

    if (sliders) {
        Array.from(sliders).forEach((slider) => {
            const swiper = new Swiper(slider, {
                slidesPerView: 'auto',
                loop: true,
                speed: 7800,
                spaceBetween: 64,
                allowTouchMove: false,
                autoplay: {
                    delay: 0,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false,
                },
            })

            // Extra sauce to guarantee slides are autoplaying
            // Necessary to fix bug where it won't start after cache clear
            setInterval(() => {
                if (swiper.running) {
                    return
                }
                if (!swiper.running) {
                    swiper.autoplay.start()
                }
                if (!swiper.animating) {
                    swiper.slideNext()
                }
            }, 1000)
        })
    }
}
